import { IBoAeFolder } from "@core/models/back-office/admin-folder/ae-folder.model";
import { IBoAeFolderDocument } from "@core/models/back-office/admin-folder/ae-folder-document.model";
import { IBoExtra } from "@core/models/back-office/extra.model";
import { IBoAddress } from "@core/models/back-office/address.model";

export const aeExtraFolderMock = {
  extra: {
    [IBoExtra.extraId]: 3670086,
    [IBoExtra.firstname]: "Tony",
    [IBoExtra.lastname]: "BOLTE",
    [IBoExtra.phone]: "0602356026",
    [IBoExtra.email]: "email.test@yopmail.com",
    [IBoExtra.birthDate]: "1958-03-26",
    [IBoExtra.nationality]: "FRANCAISE",
    [IBoExtra.securityNumber]: "18012900000000",
    [IBoExtra.nativeCountry]: "FRANCE",
    [IBoExtra.address]: {
      [IBoAddress.postalCode]: "75010",
      [IBoAddress.street]: "82 rue d'hauteville",
      [IBoAddress.city]: "PARIS",
    },
    [IBoExtra.status]: "pending_internal_verification",
    [IBoExtra.alerts]: "Document expiré",
  },
  folder: {
    [IBoAeFolder.status]: "pending_internal_verification",
    [IBoAeFolder.alert]: "Document expiré",
    [IBoAeFolder.comment]: "send Candidate Document To Validation",
    [IBoAeFolder.companyName]: "Extracadabra",
    [IBoAeFolder.vat]: "FR434435s129",
    [IBoAeFolder.iban]: "FR7314508000705361152861R70",
    [IBoAeFolder.swift]: "swiftNumber",
    [IBoAeFolder.siret]: "32323ZZZZZZZ",
    [IBoAeFolder.aeDocuments]: [
      {
        [IBoAeFolderDocument.uploadedDate]: "2022-09-22 22:55:13",
        [IBoAeFolderDocument.filename]: "justificatif_autoentrepreneur.png",
      },
    ],
    [IBoAeFolder.ribDocuments]: [
      {
        [IBoAeFolderDocument.uploadedDate]: "2022-09-22 22:55:18",
        [IBoAeFolderDocument.filename]: "identite_rib.png",
      },
      {
        [IBoAeFolderDocument.uploadedDate]: "2022-09-22 22:55:16",
        [IBoAeFolderDocument.archivedDate]: "2022-09-22 22:55:18",
        [IBoAeFolderDocument.archivedBy]: "Candidate(3670086)",
        [IBoAeFolderDocument.filename]: "/22_09_22_20_55_17_identite_rib.png",
      },
    ],
    [IBoAeFolder.identityDocuments]: [
      {
        [IBoAeFolderDocument.uploadedDate]: "2022-09-22 22:55:24",
        [IBoAeFolderDocument.filename]: "identite.png",
        [IBoAeFolderDocument.expirationDate]: "2022-09-22 22:55:24",
        [IBoAeFolderDocument.identityDocumentType]: "CNI",
      },
      {
        [IBoAeFolderDocument.uploadedDate]: "2022-09-22 22:55:23",
        [IBoAeFolderDocument.archivedDate]: "2022-09-22 22:55:24",
        [IBoAeFolderDocument.archivedBy]: "Candidate(3670086)",
        [IBoAeFolderDocument.filename]: "https://extradevsecured.s3.eu-central-1.amazonaws.com/admin/3670086/archive/22_09_22_20_55_24_identite.png",
        [IBoAeFolderDocument.expirationDate]: "2022-09-22 22:55:24",
        [IBoAeFolderDocument.identityDocumentType]: "CINE",
      },
      {
        [IBoAeFolderDocument.uploadedDate]: "2022-09-22 22:55:21",
        [IBoAeFolderDocument.archivedDate]: "2022-09-22 22:55:23",
        [IBoAeFolderDocument.archivedBy]: "Candidate(3670086)",
        [IBoAeFolderDocument.filename]: "https://extradevsecured.s3.eu-central-1.amazonaws.com/admin/3670086/archive/22_09_22_20_55_22_identite.png",
        [IBoAeFolderDocument.expirationDate]: "2032-09-22 22:55:24",
      },
    ],
  },
};
